export const liveStats = [
  { label: "24小时新增讨论", value: "2,318", unit: "条", trend: "+18%" },
  { label: "发酵中话题", value: "46", unit: "个", trend: "+6" },
  { label: "评论区留言", value: "9,742", unit: "条", trend: "+12%" },
  { label: "待核实传闻", value: "5", unit: "条", trend: "持平" },
];

export const heatRanking = [
  { id: 1, title: "选秀节目剪辑风波持续发酵", heat: 9820, category: "综艺", stage: "高位" },
  { id: 2, title: "国货美妆品牌直播口误引争议", heat: 8740, category: "品牌", stage: "发酵" },
  { id: 3, title: "短剧剧组片场纠纷录音流出", heat: 7610, category: "剧组", stage: "升温" },
  { id: 4, title: "美食探店博主标签争议被翻旧账", heat: 6480, category: "博主", stage: "升温" },
  { id: 5, title: "乐队主唱退团公告措辞被指阴阳", heat: 5230, category: "音乐", stage: "初起" },
];

export const tickerItems = [
  "选秀节目剪辑风波：节目组回应称“剪辑不存在引导”，网友评论区并不买账",
  "国货美妆品牌直播口误：品牌方凌晨发布致歉说明，代言话题热度持续走高",
  "短剧剧组片场纠纷：疑似现场录音流出，双方各执一词暂未达成一致",
  "美食探店博主标签争议：多条早期合作内容被网友翻出重新对比",
  "乐队主唱退团公告：粉丝后援会发长文梳理时间线，请求还原完整经过",
  "头部主播合约纠纷：经纪公司发布简短声明，未正面回应分成细节",
  "音乐节阵容官宣被指临时改档：主办方称以最终排期为准，退票通道已开启",
  "某新晋演员接机秩序问题：工作室呼吁理性追星，现场视频仍在传播",
];

export const topicIndex = [
  { no: "01", title: "选秀节目剪辑风波持续发酵", category: "综艺", heat: "9,820", note: "24小时新增 412 条讨论" },
  { no: "02", title: "国货美妆品牌直播口误引争议", category: "品牌", heat: "8,740", note: "评论区留言 1,930 条" },
  { no: "03", title: "短剧剧组片场纠纷录音流出", category: "剧组", heat: "7,610", note: "话题连续 3 天在榜" },
  { no: "04", title: "美食探店博主标签争议被翻旧账", category: "博主", heat: "6,480", note: "疑似早期合作内容被对比" },
  { no: "05", title: "乐队主唱退团公告措辞被指阴阳", category: "音乐", heat: "5,230", note: "后援会长文梳理时间线" },
  { no: "06", title: "头部主播合约纠纷疑似曝光", category: "直播", heat: "4,760", note: "经纪公司发布简短声明" },
  { no: "07", title: "综艺编剧疑似小号发文引猜测", category: "综艺", heat: "3,940", note: "账号已设为私密状态" },
  { no: "08", title: "音乐节阵容官宣后被指临时改档", category: "演出", heat: "3,510", note: "退票通道已经开启" },
  { no: "09", title: "游戏主播直播掉线甩锅运营", category: "直播", heat: "2,860", note: "运营方暂未公开回应" },
  { no: "10", title: "品牌代言解约传闻待核实", category: "品牌", heat: "2,410", note: "目前仅有截图流传" },
  { no: "11", title: "剧组路透照侵权争议", category: "剧组", heat: "1,980", note: "多方说法暂不一致" },
  { no: "12", title: "某新晋演员接机秩序问题", category: "艺人", heat: "1,540", note: "工作室呼吁理性追星" },
];

export const featuredCards = [
  {
    id: "flow-1",
    size: "large",
    category: "综艺",
    title: "选秀节目剪辑风波：一段被反复回放的片段，如何把讨论推向高位",
    summary:
      "节目组在凌晨回应“剪辑不存在引导”，但网友评论区把正片、花絮与直播画面并列对比，争议焦点从剪辑手法转向了赛制与镜头分配。话题在 24 小时内三度冲上热榜。",
    meta: "2小时前 · 热议中",
    views: "42.6万",
    comments: "3,180",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20still%20life%20of%20a%20vintage%20television%20set%20glowing%20in%20a%20warm%20cream%20studio%2C%20torn%20paper%20scraps%20and%20a%20magnifying%20glass%20beside%20it%2C%20terracotta%20and%20amber%20color%20grading%2C%20soft%20diffused%20light%2C%20minimal%20props%2C%20clean%20composition%20with%20generous%20negative%20space%2C%20stylized%20artistic%20photography%2C%20high%20detail%2C%20warm%20harmonious%20palette&width=1200&height=800&seq=tadpole-flow-01&orientation=landscape",
  },
  {
    id: "flow-2",
    size: "medium",
    category: "品牌",
    title: "国货美妆品牌直播口误：道歉说明发布后，代言话题反而更热",
    summary: "品牌方凌晨发布致歉说明，主动认领表述失误，但网友评论区的讨论重点已转向代言选择的背景。",
    meta: "5小时前 · 发酵中",
    views: "28.3万",
    comments: "1,930",
    image:
      "https://readdy.ai/api/search-image?query=flat%20lay%20of%20a%20smartphone%20screen%20showing%20blurred%20message%20threads%20on%20a%20warm%20cream%20surface%2C%20dried%20flowers%20and%20a%20small%20brass%20lamp%2C%20terracotta%20and%20amber%20tones%2C%20soft%20diffused%20light%2C%20minimal%20editorial%20still%20life%2C%20generous%20negative%20space%2C%20stylized%20photography%2C%20warm%20harmonious%20palette%2C%20high%20detail&width=800&height=600&seq=tadpole-flow-02&orientation=landscape",
  },
  {
    id: "flow-3",
    size: "medium",
    category: "剧组",
    title: "短剧剧组片场纠纷：疑似现场录音流出，双方各执一词",
    summary: "一段被指为现场沟通的音频在讨论区流传，剧组与合作方先后给出不同说法，目前均未提供完整记录。",
    meta: "7小时前 · 升温",
    views: "19.7万",
    comments: "1,264",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20stacked%20newspapers%20and%20a%20cracked%20mirror%20on%20a%20warm%20cream%20backdrop%2C%20terracotta%20and%20amber%20color%20grading%2C%20soft%20studio%20lighting%2C%20minimal%20editorial%20composition%20with%20negative%20space%2C%20stylized%20artistic%20photography%2C%20high%20detail%2C%20warm%20harmonious%20palette%2C%20quiet%20moody%20atmosphere&width=800&height=600&seq=tadpole-flow-03&orientation=landscape",
  },
  {
    id: "flow-4",
    size: "small",
    category: "博主",
    title: "美食探店标签争议被翻旧账，早期合作内容重新对比",
    summary: "多条早前内容被网友截图并列，评论区围绕“是否标注合作”展开讨论。",
    meta: "11小时前",
    views: "12.1万",
    comments: "806",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20still%20life%20of%20scattered%20playing%20cards%20and%20a%20spilled%20cup%20of%20coffee%20on%20a%20warm%20cream%20table%2C%20terracotta%20and%20amber%20accents%2C%20soft%20diffused%20daylight%2C%20minimal%20props%2C%20clean%20composition%2C%20stylized%20artistic%20photography%2C%20generous%20negative%20space%2C%20high%20detail%2C%20warm%20harmonious%20palette&width=800&height=600&seq=tadpole-flow-04&orientation=landscape",
  },
  {
    id: "flow-5",
    size: "small",
    category: "音乐",
    title: "乐队主唱退团公告措辞被指阴阳，后援会发长文梳理时间线",
    summary: "退团公告中一句表述被反复解读，粉丝整理公开行程希望还原完整经过。",
    meta: "1天前",
    views: "9.4万",
    comments: "612",
    image:
      "https://readdy.ai/api/search-image?query=stylized%20editorial%20scene%20of%20an%20empty%20theater%20seat%20row%20under%20warm%20amber%20light%2C%20plush%20warm%20cream%20and%20terracotta%20upholstery%2C%20soft%20shadows%2C%20minimal%20composition%20with%20generous%20negative%20space%2C%20artistic%20photography%2C%20high%20detail%2C%20warm%20harmonious%20palette&width=800&height=600&seq=tadpole-flow-05&orientation=landscape",
  },
];

export const featureFilters = ["全部", "综艺", "品牌", "剧组", "博主", "音乐"];

export const timelineStages = [
  {
    time: "09.07 22:40",
    tag: "起点",
    title: "片段被单独截取传播",
    desc: "一段节目正片截图在讨论区扩散，网友开始对比完整版与剪辑版之间的差异。",
  },
  {
    time: "09.08 01:10",
    tag: "发酵",
    title: "话题首次进入热榜前列",
    desc: "相关关键词搜索量在两小时内快速走高，多个讨论区出现整理帖与时间线长文。",
  },
  {
    time: "09.08 09:30",
    tag: "回应",
    title: "节目组发布简短回应",
    desc: "节目组称剪辑以节目呈现为准，未对赛制与镜头分配的具体质疑逐条说明。",
  },
  {
    time: "09.08 16:00",
    tag: "分化",
    title: "评论区观点出现明显分层",
    desc: "围绕“剪辑问题”与“赛制问题”的讨论各自成团，双方在评论区内高频互动。",
  },
  {
    time: "09.09 11:20",
    tag: "高位",
    title: "衍生话题开始独立传播",
    desc: "赛制讨论、往季对比等衍生话题独立成榜，热度由单一事件扩散到更大范围。",
  },
  {
    time: "09.10 08:00",
    tag: "当下",
    title: "舆论仍在发酵，尚无定论",
    desc: "各方暂未提供更多完整材料，讨论重心落在细节比对与当事人后续动向。",
  },
];

export const opinionGroups = [
  {
    key: "program",
    label: "认为节目组需说明",
    hint: "主张完整材料与赛制透明",
    items: [
      {
        name: "晚风翻页",
        role: "长期观众",
        stance: "主张回应",
        text: "与其只说“不存在引导”，不如把完整素材和赛制切换的依据一起放出来，讨论自然就散了。",
      },
      {
        name: "南岸记录",
        role: "内容观察",
        stance: "主张核实",
        text: "现在流传的截图太碎，建议先以官方完整版为准，逐条比对再下判断，避免被二次剪辑带偏。",
      },
      {
        name: "第七个抽屉",
        role: "讨论区常客",
        stance: "期待说明",
        text: "赛制在开播前是否公开过完整规则？这一条如果能说清楚，评论区一半的争议都会降温。",
      },
    ],
  },
  {
    key: "artist",
    label: "认为属于正常讨论",
    hint: "倾向把焦点放回作品本身",
    items: [
      {
        name: "橘子汽水",
        role: "路人视角",
        stance: "中立观望",
        text: "我就在评论区围观，感觉两边情绪都挺满的，其实很多争论点最后都回到了各自的立场。",
      },
      {
        name: "深夜便利店",
        role: "追更用户",
        stance: "关注作品",
        text: "剪辑可以讨论，但别把所有镜头都往心机上想，回归作品质量可能更有意思一些。",
      },
      {
        name: "半杯温茶",
        role: "普通网友",
        stance: "等待后续",
        text: "目前公开的信息都不完整，先标记一下时间线，等更多材料出来再看看走向。",
      },
    ],
  },
  {
    key: "neutral",
    label: "中立围观不吃情绪",
    hint: "只看公开材料与可核实细节",
    items: [
      {
        name: "数据小站",
        role: "热度观察",
        stance: "数据说话",
        text: "从搜索曲线看，这波热度在回应后不降反升，说明大家更关心的是细节而不是结论。",
      },
      {
        name: "路过打勾",
        role: "吃瓜群众",
        stance: "谨慎吃瓜",
        text: "截图、录音、匿名帖都在传，能核实的其实不多，先当素材看，别急着站队。",
      },
      {
        name: "北纬三十",
        role: "评论区留言",
        stance: "理性讨论",
        text: "评论区最有价值的是有人把正片、花絮、直播时间点整理成表，比情绪输出有用多了。",
      },
    ],
  },
];

export const commentFeed = [
  { user: "荔枝味的雾", city: "杭州", time: "12分钟前", content: "把三个版本的时间点对齐之后，很多争论其实能自己解释清楚，建议先看完整版。", likes: 286, replies: 42, tag: "高赞" },
  { user: "纸飞机不飞", city: "成都", time: "38分钟前", content: "评论区比正片还热闹，两边的整理帖我都看了，材料给的确实不太一样。", likes: 194, replies: 17, tag: "热议" },
  { user: "沿着河边走", city: "武汉", time: "1小时前", content: "理性吃瓜，等官方完整回应再下结论，现在很多截图没有来源。", likes: 173, replies: 9, tag: "理性" },
  { user: "路灯下的猫", city: "南京", time: "2小时前", content: "赛制公开透明才是关键，剪辑只是表象，规则说清楚了大家自然没那么多猜测。", likes: 142, replies: 31, tag: "观点" },
  { user: "二十点整", city: "西安", time: "3小时前", content: "从搜索热度看这波还没到顶，衍生话题已经独立成榜了，继续围观。", likes: 118, replies: 6, tag: "观察" },
  { user: "薄荷与青柠", city: "长沙", time: "5小时前", content: "希望当事人后续能补充说明，目前公开材料太少，评论区靠猜的成分有点高。", likes: 96, replies: 12, tag: "期待" },
];

export const collections = [
  {
    title: "近期发酵中的话题合集",
    desc: "把还在升温、尚未有定论的话题集中放在一起，方便按时间线连续围观。",
    count: "18 个话题",
    badge: "持续更新",
    image:
      "https://readdy.ai/api/search-image?query=stack%20of%20vintage%20film%20reels%20and%20a%20clapperboard%20on%20a%20warm%20cream%20background%2C%20terracotta%20and%20amber%20color%20grading%2C%20soft%20diffused%20studio%20light%2C%20minimal%20editorial%20still%20life%2C%20generous%20negative%20space%2C%20stylized%20artistic%20photography%2C%20high%20detail%2C%20warm%20harmonious%20palette&width=800&height=600&seq=tadpole-coll-01&orientation=landscape",
    topics: ["选秀剪辑风波", "品牌直播口误", "短剧剧组录音", "音乐节改档传闻"],
  },
  {
    title: "评论区高赞整理合集",
    desc: "筛选网友评论中信息量更大的长评与时间线整理，按讨论方向分组呈现。",
    count: "126 条长评",
    badge: "网友整理",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20composition%20of%20glowing%20comment%20bubbles%20and%20hashtag%20signs%20on%20a%20warm%20cream%20surface%2C%20terracotta%20and%20amber%20accents%2C%20soft%20diffused%20light%2C%20minimal%20artistic%20layout%2C%20generous%20negative%20space%2C%20stylized%20photography%2C%20high%20detail%2C%20warm%20harmonious%20palette&width=800&height=600&seq=tadpole-coll-02&orientation=landscape",
    topics: ["时间线对齐帖", "往季对比整理", "声明原文留档", "关键词热度解读"],
  },
  {
    title: "被反转的话题合集",
    desc: "曾经热议后被新材料修正的话题，专门归档，提醒围观时多留一份谨慎。",
    count: "9 个旧话题",
    badge: "已归档",
    image:
      "https://readdy.ai/api/search-image?query=open%20notebook%20with%20handwritten%20notes%20and%20a%20red%20thread%20connecting%20pinned%20photos%20on%20a%20warm%20cream%20wall%2C%20terracotta%20and%20amber%20tones%2C%20soft%20diffused%20light%2C%20minimal%20editorial%20composition%2C%20generous%20negative%20space%2C%20stylized%20artistic%20photography%2C%20high%20detail%2C%20warm%20harmonious%20palette&width=800&height=600&seq=tadpole-coll-03&orientation=landscape",
    topics: ["代言解约旧闻", "路透侵权争议", "直播掉线误会", "接机秩序澄清"],
  },
];

export const heroImage =
  "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20glowing%20screens%20and%20scattered%20message%20bubbles%20on%20a%20warm%20cream%20background%2C%20terracotta%20and%20amber%20accents%2C%20soft%20diffused%20studio%20light%2C%20minimal%20artistic%20composition%20with%20generous%20negative%20space%2C%20stylized%20graphic%20texture%2C%20high%20detail%2C%20warm%20harmonious%20palette&width=600&height=400&seq=tadpole-hero-01&orientation=landscape";

export const keywordTags = [
  "蝌蚪黑料",
  "蝌蚪黑料热议",
  "蝌蚪黑料舆论发酵",
  "蝌蚪黑料评论区",
  "蝌蚪黑料网友评论",
];